module.exports = __webpack_public_path__ + "static/media/mv.85a2f7bd.svg";